import React, { FC, Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Badge } from "antd";
// import { head } from "lodash";
import moment from "moment";

import membersService from "@services/members.service";
// import { formatDisplayDate } from "@utils/helpers";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { MEMBERS_DETAILS_SCREEN_TITLE, rightDrawerActions, UPCOMING } from "@utils/constants";
import BellNew from "@assets/bell.svg";
import "./action-bar.scss";
import { get, uniqBy } from "lodash";
import { milleniumClientCheck, centricClientCheck } from "@utils/helpers";

type TActionBarProps = {
  actionClickHandler?: any;
  newNotificationFlag?: boolean;
  members?: any;
};

const ActionBar: FC<TActionBarProps> = ({ actionClickHandler, newNotificationFlag, members }: TActionBarProps) => {
  const currentScreen = useGlobalInformationStore((state) => state.currentScreen);

  const memberDetailGlobalReminder = useGlobalInformationStore((state) => state.memberDetailGlobalReminder);
  const setMemberDetailGlobalReminder = useGlobalInformationStore((state) => state.setMemberDetailGlobalReminder);
  const memberDetailGlobalAlert = useGlobalInformationStore((state) => state.memberDetailGlobalAlert);
  const setMemberDetailGlobalAlert = useGlobalInformationStore((state) => state.setMemberDetailGlobalAlert);
  const isCentric = centricClientCheck()

  useEffect(() => {
    console.log("ActionBar.useEffect");
    if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
      const getReminders = () => {
        console.log("ActionBar.getReminders");
        let isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
        if (members) {
          const page:number = 1;
          const pageLimit:number = 5;
          const fromDate = moment.utc(moment(`${moment().format("YYYY-MM-DD")} 00:00:00`).utc());
          membersService.getPastAndFutureReminder(isAllCM, members, page, pageLimit, fromDate, UPCOMING).subscribe({
            next: (res: any) => {
              setMemberDetailGlobalReminder(res.data.data?.currentAndfutureReminders)
            },
            error: (err) => {
              setMemberDetailGlobalReminder([]);
              console.log(err);
            },
          });
        }
      };

      const getAlert = () => {
        console.log("ActionBar.getAlert");
        let isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
        if (members) {
          membersService.getAllAlerts(isAllCM, members).subscribe({
            next: (res) => {
              const data = res?.data?.data;
              let alertsArray = uniqBy([...memberDetailGlobalAlert?.alerts , ...data?.alerts] , 'alertId').sort((a, b) => {
                const dateA = moment(a.alertDate);
                const dateB = moment(b.alertDate);
                return dateB.diff(dateA); // Compare in descending order
              })
              setMemberDetailGlobalAlert({...memberDetailGlobalAlert , alerts : alertsArray , totalAlerts : data?.totalCount , latest_datetime : get(alertsArray , '[0].alertDate') , datetime : get(alertsArray , '[0].alertDate')});
            },
            error: (err) => {
              setMemberDetailGlobalAlert([]);
            },
          });
        }
      };
      getReminders();
      getAlert();
    }
  }, [members, currentScreen, setMemberDetailGlobalAlert, setMemberDetailGlobalReminder]);

  const location = useLocation();
  let _rightDrawerActions = rightDrawerActions;
  if (location.pathname === "/members" || isCentric) {
    _rightDrawerActions = _rightDrawerActions?.filter((action) => action.id !== "Alerts");
  }
  if(!milleniumClientCheck()){
    _rightDrawerActions = _rightDrawerActions?.filter((action) => action.id !== "Recorded Entries");
  }

  const getOptionView = () => {
    return _rightDrawerActions?.map((action, index) => {


      return (
        <Fragment key={index}>
          {action.id !== "Notification" && (
            <div className="rightactionbar-option">
              <Badge
                dot={
                  currentScreen === MEMBERS_DETAILS_SCREEN_TITLE &&
                  (action.id === "Reminders"
                    ? memberDetailGlobalReminder?.filter((rem: any) => moment(rem.reminderEndDate) >= moment()).length > 0
                      ? true
                      : false
                    : action.id === "Alerts"
                    ? memberDetailGlobalAlert?.alerts?.filter((alert: any) => alert.alertReadStatus === "N").length > 0
                      ? true
                      : false
                    : false)
                }
              >
                <img
                  src={action.id === "Notification" ? (newNotificationFlag ? BellNew : action.icon) : action.icon}
                  alt={action.alt}
                  onClick={() => actionClickHandler(action)}
                  className="rightactionbar--option-icon"
                />
              </Badge>
            </div>
          )}
          {/* members[0].reminders */}
        </Fragment>
      );
    });
  };

  return <div className="rightActionBar sticky-align-header">{getOptionView()}</div>;
};

export default ActionBar;
